var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVolumeUpVolumeBar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 30,
    viewBox: "0 0 33 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2956_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.4666 0.00151314V29.9956C14.8727 29.9956 14.2817 29.9956 13.6936 29.9956C13.6148 29.9956 13.5287 29.9028 13.463 29.8364C10.5007 26.8487 7.54074 23.857 4.58325 20.8615C4.47191 20.7407 4.40628 20.5841 4.39792 20.4192C4.38819 16.8143 4.38819 13.2099 4.39792 9.60594C4.4085 9.42992 4.48035 9.26334 4.60076 9.13567C7.53782 6.15483 10.4822 3.18186 13.4338 0.21675C13.5629 0.0992101 13.7274 0.0290846 13.9008 0.0177272C14.4086 -0.0117568 14.9179 0.00151314 15.4666 0.00151314ZM14.1532 1.40348C14.0715 1.47129 14.0321 1.49783 14 1.53026C11.2965 4.26048 8.59434 6.99267 5.89369 9.72682C5.78438 9.86467 5.72607 10.0367 5.72879 10.2133C5.72003 13.3991 5.7288 16.5863 5.71712 19.7735C5.71182 19.8812 5.72999 19.9888 5.77033 20.0886C5.81067 20.1885 5.87221 20.2782 5.9506 20.3514C8.59191 23.005 11.2284 25.6644 13.8599 28.3298C13.9417 28.4123 14.0307 28.4875 14.1518 28.5996L14.1532 1.40348Z",
    fill: "#3E30D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.6719 5.12872L25.5474 4.19849C26.9555 5.61039 28.0739 7.28905 28.8387 9.13831C29.6034 10.9876 29.9995 12.9711 30.0043 14.9753C30.009 16.9794 29.6223 18.9648 28.8663 20.8178C28.1103 22.6707 26.9998 24.3547 25.5985 25.7734L24.704 24.8373C29.7721 19.6879 30.2303 10.8368 24.6719 5.12872Z",
    fill: "#3E30D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 9.35229H3.70951V10.6658H1.33963V19.3267H3.71682V20.6403H0V9.35229Z",
    fill: "#3E30D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.3594 8.41764L22.286 7.49036C26.2845 11.4707 26.4858 18.2682 22.286 22.5272L21.374 21.5867C25.0601 17.91 24.8077 11.795 21.3594 8.41764Z",
    fill: "#3E30D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.1094 11.7111L19.0346 10.8265C21.1243 12.6442 21.5314 16.769 19.0346 19.2074L18.1415 18.2654C18.978 17.3817 19.4422 16.2044 19.4362 14.9817C19.4302 13.7589 18.9545 12.5864 18.1094 11.7111Z",
    fill: "#3E30D1"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2956_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 33,
    height: 30,
    fill: "#3E30D1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVolumeUpVolumeBar);
export default __webpack_public_path__ + "static/media/volumeUpVolumeBar.5616385eee535258aeef86dcc442cfa6.svg";
export { ForwardRef as ReactComponent };